/* eslint-disable camelcase */
import type { FilterData } from '../../FilterData';
import { delimit } from '../../../../../common/Responses/Filters/Query/queryUtils';
import type { LocalFilterQuery, QueryKey } from './LocalFilterQuery';

const defaultQuery: LocalFilterQuery = {
  url: undefined,
  url_contains: undefined,
  url_not_contains: undefined,
  url_starts: undefined,
  url_ends: undefined,
  completion: undefined,
  keyword_contains: undefined,
  keyword_not_contains: undefined,
  rating: undefined,
  recording: undefined,
};

function getQueryKey(filter: FilterData): QueryKey | undefined {
  if (filter.value === undefined) return undefined;
  switch (filter.type) {
    case 'url':
      switch (filter.value.operation) {
        case 'CONTAINS':
          return 'url_contains';
        case 'NOT_CONTAINS':
          return 'url_not_contains';
        case 'STARTS_WITH':
          return 'url_starts';
        case 'ENDS_WITH':
          return 'url_ends';
        case 'IS':
          return 'url';
      }
    case 'completion':
      return 'completion';
    case 'reaction':
      return 'rating';
    case 'keyword':
      switch (filter.value.operation) {
        case 'CONTAINS':
          return 'keyword_contains';
        case 'NOT_CONTAINS':
          return 'keyword_not_contains';
      }
    case 'recording':
      return 'recording';
  }
}

function getQueryValue(filter: FilterData): string | undefined {
  if (filter.value === undefined) return undefined;
  switch (filter.type) {
    case 'url':
      return filter.value.value;
    case 'completion':
      return filter.value;
    case 'recording':
      return filter.value;
    case 'reaction':
      return delimit(...filter.value.sort().map((rating) => rating.toString()));
    case 'keyword':
      return filter.value.value;
  }
}

function getQuery(filter: FilterData): Partial<LocalFilterQuery> | undefined {
  const key = getQueryKey(filter);
  if (key === undefined) return undefined;
  const value = getQueryValue(filter);
  if (value === undefined) return undefined;
  return { [key]: value };
}

export const convertLocalFiltersToQuery = (localFilters: FilterData[]): LocalFilterQuery => {
  return Object.assign(
    { ...defaultQuery },
    ...localFilters.map(getQuery).filter((query): query is LocalFilterQuery => query !== undefined),
  );
};
